import React from 'react';
import { Alert, Button } from 'antd';
import { SwapOutlined } from '@ant-design/icons';

/**
 * Floating banner shown when an admin is impersonating a tenant.
 * Reads original_token from localStorage and provides a "Return to Admin" button.
 */
const ImpersonationBanner: React.FC = () => {
  const originalToken = localStorage.getItem('original_token');
  if (!originalToken) return null;

  const handleReturn = () => {
    localStorage.setItem('token', originalToken);
    localStorage.removeItem('original_token');
    localStorage.removeItem('impersonation_token');
    // Reload user info from the restored admin token
    try {
      const payload = JSON.parse(atob(originalToken.split('.')[1]));
      localStorage.setItem('user', JSON.stringify({
        id: payload.id,
        role: payload.role,
        email: payload.email,
        company_id: payload.company_id,
      }));
    } catch {
      // If decode fails, clear everything and force login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    window.location.href = '/admin';
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}>
      <Alert
        type="warning"
        banner
        showIcon={false}
        message={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
            <span style={{ fontWeight: 600 }}>Impersonation Mode</span>
            <span>You are viewing as a tenant.</span>
            <Button
              size="small"
              type="primary"
              icon={<SwapOutlined />}
              onClick={handleReturn}
            >
              Return to Admin
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default ImpersonationBanner;
